// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home {
  min-height: 80vh;
}
.home .statics {
  background-color: #fff;
  padding: 20px;
  border-radius: 5px;
  margin-bottom: 20px;
}
.home .statics h2 {
  margin-bottom: 50px;
}
.home .statics .col {
  display: flex;
}
.home .statics .col .image {
  width: 45px;
  height: 45px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 10px;
}
.home .statics .col div {
  display: flex;
  flex-direction: column;
}
.home .statics .col div span {
  margin: 0;
  font-size: 14px;
}
.home .statics .col div span:first-child {
  font-weight: bold;
  font-size: 17px;
}
.home .alerts .col {
  padding: 10px;
  display: flex;
}
.home .alerts .col .cont {
  position: relative;
  flex: 1 1;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  padding: 20px 20px 20px;
  border-radius: 5px;
}
.home .alerts .col .cont h5 {
  margin-bottom: 30px;
}
.home .alerts .col .cont .MuiFormGroup-root {
  margin-top: -30px;
}
.home .alerts .col .cont .MuiFormGroup-root .MuiTypography-root {
  font-size: 17px;
  font-weight: bold;
}
.home .alerts .col form {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.home .loading-spinner {
  height: 300px;
}

.dark .statics,
.dark .alerts .col .cont {
  background-color: var(--darkSecondColor);
  color: var(--darkFont);
}`, "",{"version":3,"sources":["webpack://./src/components/HomePage/home.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;AACF;AAAE;EACE,sBAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;AAEJ;AADI;EACE,mBAAA;AAGN;AADI;EACE,aAAA;AAGN;AAFM;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;AAIR;AAFM;EACE,aAAA;EACA,sBAAA;AAIR;AAHQ;EACE,SAAA;EACA,eAAA;AAKV;AAHQ;EACE,iBAAA;EACA,eAAA;AAKV;AACI;EACE,aAAA;EACA,aAAA;AACN;AAAM;EACE,kBAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;EACA,sBAAA;EACA,uBAAA;EACA,kBAAA;AAER;AADQ;EACE,mBAAA;AAGV;AADQ;EACE,iBAAA;AAGV;AAFU;EACE,eAAA;EACA,iBAAA;AAIZ;AAAM;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;AAER;AAEE;EACE,aAAA;AAAJ;;AAIE;;EAEE,wCAAA;EACA,sBAAA;AADJ","sourcesContent":[".home {\n  min-height: 80vh;\n  .statics {\n    background-color: #fff;\n    padding: 20px;\n    border-radius: 5px;\n    margin-bottom: 20px;\n    h2 {\n      margin-bottom: 50px;\n    }\n    .col {\n      display: flex;\n      .image {\n        width: 45px;\n        height: 45px;\n        border-radius: 5px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        margin-left: 10px;\n      }\n      div {\n        display: flex;\n        flex-direction: column;\n        span {\n          margin: 0;\n          font-size: 14px;\n        }\n        span:first-child {\n          font-weight: bold;\n          font-size: 17px;\n        }\n      }\n    }\n  }\n  .alerts {\n    .col {\n      padding: 10px;\n      display: flex;\n      .cont {\n        position: relative;\n        flex: 1;\n        display: flex;\n        flex-direction: column;\n        background-color: #fff;\n        padding: 20px 20px 20px;\n        border-radius: 5px;\n        h5 {\n          margin-bottom: 30px;\n        }\n        .MuiFormGroup-root {\n          margin-top: -30px;\n          .MuiTypography-root {\n            font-size: 17px;\n            font-weight: bold;\n          }\n        }\n      }\n      form {\n        height: 100%;\n        display: flex;\n        flex-direction: column;\n        justify-content: space-between;\n      }\n    }\n  }\n  .loading-spinner {\n    height: 300px;\n  }\n}\n.dark {\n  .statics,\n  .alerts .col .cont {\n    background-color: var(--darkSecondColor);\n    color: var(--darkFont);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
